import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../../actions/addresses";
import SecretSeedModal from "../sharedComponent/secretSeedModal";
import Loader from "../../Loader/Loader";
import * as sdk from "boa-sdk-ts";
import { WalletMA, WalletUnfreezeBuilder, WalletResultCode } from "boa-sdk-ts";
import FeeOption from "../sharedComponent/feeOption";
import { addressFormat, amountFormat } from "../../../utils/WalletUtils";
import { ErrorCheckUtil } from "../../../utils/ErrorCheckUtil";
import TransactionOverview from "../sendBoa/sendBoaOverview";

const Unfreezing = (props) => {
  // These are states of current component
  const { t, selectedAddress } = props;
  const [fee, SetFee] = useState("");

  const [unFreezingUtxo, setUnFreezingUtxo] = useState([]);

  const [summaryFrozen, setSummaryFrozen] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [loader, setLoader] = useState(false);
  const [FeeError, SetFeeError] = useState(null);

  const { accounts, builders, client } = WalletMA.instance();
  const [feeOption, setFeeOption] = useState("1");

  const [senderList, setSenderList] = useState([]);
  const [readModeList, setReadModeList] = useState([]);
  const [secretKeyModal, setSecretKeyModal] = useState(false);
  const [transactionOverviewData, setTransactionOverviewData] = useState();

  useEffect(() => {
    console.log("UNFREEZING_INIT");
    initBuilder();
    return () => {
      console.log("UNFREEZING_END");
      const builder = getBuilder();
      if (builder) {
        builder.removeEventListener(
          sdk.Event.CHANGE_BALANCE,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_RECEIVER,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_SENDER,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_TX_FEE,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_UTXO_ITEM,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_UTXO_SELECTION,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_UTXO_SUMMARY,
          buildersEventHandler
        );
        builder.removeEventListener(sdk.Event.ERROR, buildersEventHandler);
        builder.clear();
      }
      builders.delete("UNFREEZING");
    };
  }, []);

  const initBuilder = async () => {
    const res = await createBuilder();
    setBuilder(res);
    await replaceSender();
  };

  const createBuilder = async () => {
    const builder = new WalletUnfreezeBuilder(client);
    builder.addEventListener(sdk.Event.CHANGE_BALANCE, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_RECEIVER, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_SENDER, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_TX_FEE, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_UTXO_ITEM, buildersEventHandler);
    builder.addEventListener(
      sdk.Event.CHANGE_UTXO_SELECTION,
      buildersEventHandler
    );
    builder.addEventListener(
      sdk.Event.CHANGE_UTXO_SUMMARY,
      buildersEventHandler
    );
    builder.addEventListener(sdk.Event.ERROR, buildersEventHandler);
    return builder;
  };

  const getBuilder = () => {
    return builders.get("UNFREEZING");
  };
  const setBuilder = (builder) => {
    builders.set("UNFREEZING", builder);
  };

  const buildersEventHandler = (e, data) => {
    switch (e) {
      case sdk.Event.CHANGE_BALANCE:
        console.log("Event.CHANGE_BALANCE:");
        break;
      case sdk.Event.CHANGE_RECEIVER:
        console.log("Event.CHANGE_RECEIVER:");
        if (getBuilder()) {
          console.log("RECEIVER_LENGTH:" + getBuilder().receivers.items.length);
        }
        break;
      case sdk.Event.CHANGE_SENDER:
        console.log("Event.CHANGE_SENDER:");
        const b = getBuilder();
        if (b) {
          setSenderList([...getBuilder().senders.items]);
          console.log("senders_LENGTH:" + getBuilder().senders.items.length);
        }
        break;
      case sdk.Event.CHANGE_TX_FEE:
        console.log("Event.CHANGE_TX_FEE:" + data.toString());
        SetFee(data);
        break;
      case sdk.Event.CHANGE_UTXO_ITEM:
        console.log("Event.CHANGE_UTXO_ITEM:");
        if (getBuilder()) {
          const utxos = getBuilder().utxos;
          setUnFreezingUtxo([...utxos]);
          if (utxos && utxos.length < 1) {
            setSummaryFrozen([]);
          }
        }
        break;
      case sdk.Event.CHANGE_UTXO_SUMMARY:
        console.log("Event.CHANGE_UTXO_SUMMARY:");
        if (getBuilder()) {
          console.log("SUMMARY:" + getBuilder().summary.items);
          setSummaryFrozen([...getBuilder().summary.items]);
        }
        break;
      case sdk.Event.CHANGE_UTXO_SELECTION:
        console.log("Event.CHANGE_UTXO_SELECTION:");
        break;
      case sdk.Event.ERROR:
        console.log("Event.ERROR:" + data);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (selectedAddress) {
      replaceSender();
    }
    if (showConfirm) {
      setShowConfirm(false);
    }
  }, [selectedAddress]);

  const replaceSender = async () => {
    const b = getBuilder();
    if (b) {
      await b.clearSender(false);
      await b.addSender(
        accounts.selected_account,
        accounts.selected_account.balance.spendable
      );
    }
  };

  var countDecimals = function (value) {
    let text = value.toString();
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf("e-") > -1) {
      let [base, trail] = text.split("e-");
      let deg = parseInt(trail, 10);
      return deg;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
      return value.toString().split(".")[1].length || 0;
    }
    return 0;
  };

  const onChangeFee = (evt) => {
    let isDecimal = /^[-+]?[0-9]+\.[0-9]+$/.test(evt.target.value);
    if (isDecimal) {
      let noDigitAfterDecimal = countDecimals(evt.target.value);
      if (noDigitAfterDecimal > 7) {
        evt.preventDefault();
      } else {
        if (evt.keyCode === 8) {
          SetFee(evt.target.value);
        }
        // else if (evt.keyCode < 48 || (evt.keyCode > 57 && evt.keyCode < 96)) {
        //   evt.preventDefault();
        // }
        else {
          SetFee(evt.target.value);
        }
      }
    } else {
      if (evt.keyCode === 8) {
        SetFee(evt.target.value);
      }
      // else if (evt.keyCode < 48 || (evt.keyCode > 57 && evt.keyCode < 96)) {
      //   evt.preventDefault();
      // }
      else {
        SetFee(evt.target.value);
      }
    }
  };

  const stringToDecimal = (amount) => {
    let damount;
    let error;
    try {
      damount = new Big(amount.toString());
    } catch {
      error = "Invalid amount";
      return { damount, error };
    }
    return { damount, error };
  };

  // Method to hide confirm div
  const hideConfirmDiv = () => {
    setShowConfirm(false);
  };

  // FeeOptionChangeEvent
  const feeOptionChangeHandler = async (e) => {
    setFeeOption(e.target.value);
  };

  const secretSeedModalCloseHandler = () => {
    setSecretKeyModal(false);
    if (getBuilder().getReadOnlyAccount().length === 0) {
      getTransactionOverview();
    }
  };

  const utxoChangeCheckHandler = (item, checked) => {
    getBuilder().selectUTXO(item.utxo.utxo, checked);
  };

  // Method to handletranscation
  const nextTransactionOverview = async (e) => {
    let readModeList = getBuilder().getReadOnlyAccount();
    if (readModeList.length > 0) {
      setReadModeList(readModeList);
      setSecretKeyModal(true);
    } else {
      await getTransactionOverview();
    }
  };

  const getTransactionOverview = async (e) => {
    const builder = getBuilder();
    const res = await builder.getTransactionOverview();
    if (ErrorCheckUtil.resCodeCheck(res) && res.data) {
      setTransactionOverviewData(res.data);
      setShowConfirm(true);
    }
  };

  // Method to send Agora Transaction
  const sendToAgoraTransaction = async () => {
    const builder = getBuilder();
    const tx_res = builder.buildTransaction();

    if (ErrorCheckUtil.resCodeCheck(tx_res)) {
      const tx = tx_res.data;
      const res = await client.sendTransaction(tx);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        props.history.push("/success");
      }
    }
  };

  return (
    <>
      {/* Transcation Confirmation screen */}
      {showConfirm ? (
        <TransactionOverview
          hideConfirmDiv={hideConfirmDiv}
          sendToAgoraTransaction={sendToAgoraTransaction}
          transactionOverviewData={transactionOverviewData}
        />
      ) : (
        <div className="Content">
          <div className="TableBg cardBg">
            <div className="ContHeader">
              <h3>{t("Select_Unfreezing")}</h3>
            </div>
            <div className="table-responsive unfreezing-utxo-table">
              <table>
                <thead className="tableHead">
                  <tr>
                    <th>{t("UTXO")}</th>
                    <th>{t("Block_Height")}</th>
                    <th>{t("Amount")}</th>
                  </tr>
                </thead>
                {loader ? (
                  <Loader />
                ) : unFreezingUtxo.length > 0 ? (
                  <tbody className="tableBody">
                    {unFreezingUtxo.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="address-check">
                            <input
                              type="checkbox"
                              id="address"
                              name="address"
                              value="address"
                              onChange={(e) => {
                                utxoChangeCheckHandler(item, e.target.checked);
                              }}
                              checked={item.utxo.selected}
                              // onClick={(e) => AddUTxo(item)}
                            />
                            <div className="purpleText tooltip1">
                              <label htmlFor="address">
                                {addressFormat(item.utxo.utxo.toString())}
                                <div className="tooltiptext1">
                                  <p>{item.utxo.utxo.toString()}</p>
                                </div>
                              </label>
                            </div>
                          </div>
                        </td>
                        <td>
                          {parseFloat(
                            item.utxo.height.toString()
                          ).toLocaleString("en-US")}
                        </td>
                        <td>
                          {amountFormat(item.utxo.amount)}
                          {" BOA"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr className="noData">
                      <td className="inner">
                        <h3 className="text-center mb-3">
                          {t("sorry_no_data")}
                        </h3>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
            <div className="table-responsive unfreezing-table">
              <table>
                <thead className="tableHead">
                  <tr>
                    <th>{t("Address")}</th>
                    <th>{t("Amount_Unfrozen")}</th>
                    <th>{t("Frozen_Amount")}</th>
                    <th>{t("Freezing_Fee")}</th>
                  </tr>
                </thead>
                {summaryFrozen && summaryFrozen.length > 0 ? (
                  <tbody className="tableBody">
                    {summaryFrozen.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="tooltip1 purpleText">
                            {addressFormat(item.account.address.toString())}
                            <div className="tooltiptext1">
                              <p>{item.account.address.toString()}</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          {amountFormat(item.to_be_unfrozen)}
                          {" BOA"}
                        </td>
                        <td>
                          {amountFormat(item.frozen_balance)}
                          {" BOA"}
                        </td>
                        <td>
                          {amountFormat(item.deposit)}
                          {" BOA"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr className="noData">
                      <td className="inner">
                        <h3 className="text-center mb-3">
                          {t("sorry_no_data")}
                        </h3>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>

          <FeeOption
            fee={fee}
            feeOption={feeOption}
            error={FeeError}
            feeOptionChangeHandler={feeOptionChangeHandler}
          >
            <div className="TransactionFee">
              <div />
              <div>
                <button
                  className="btn btn-default senderBtn"
                  color="primary"
                  disabled={
                    !(
                      getBuilder() &&
                      getBuilder().validate().code === WalletResultCode.Success
                    )
                  }
                  onClick={nextTransactionOverview}
                >
                  {t("NEXT")}
                </button>
              </div>
            </div>
          </FeeOption>
          <SecretSeedModal
            readModeList={readModeList}
            secretKeyModal={secretKeyModal}
            secretSeedModalCloseHandler={secretSeedModalCloseHandler}
          />
        </div>
      )}
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Unfreezing))
);
